import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

const SCROLL_TO_PRACTICE = 'Practice';

const useScrollToDPPSection = (isDPP = false, isFetchingDpps = true) => {
  const {
    query: { view }
  } = useRouter();
  const dppFeedRowRef = useRef();
  const isScrollToPractice = view === SCROLL_TO_PRACTICE;

  useEffect(() => {
    if (isDPP && !isFetchingDpps && isScrollToPractice) {
      dppFeedRowRef.current?.scrollIntoView({
        behaviour: 'smooth',
        block: 'center'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDPP, isFetchingDpps]);

  return {
    dppFeedRowRef: isDPP && isScrollToPractice ? dppFeedRowRef : null
  };
};

export default useScrollToDPPSection;
